export enum QuestionnaireType {
  AdmitDischarge = "admitDischarge",
  Transport = "transport",
  EstimatedBloodLoss = "estimatedBloodLoss",
  ShoulderDystocia = "shoulderDystocia",
  Birthing = "birthing",
  FetalHeartRate = "fetal_heart_rate",
  LaborVitals = "labor_vitals",
  Contractions = "contractions",
  CervicalExam = "cervical_exam",
  RuptureOfMembranes = "rupture_of_membranes",
  Position = "position",
  AssessmentNote = "assessment_note",
  Membranes = "membranes",
  InputOutput = "inputOutput",
  MedsAndTherapies = "medsAndTherapies",
  NewLocation = "newLocation",
  FullLaborUpdate = "fullLaborUpdate",
  Resuscitation = "resuscitation",
  PostpartumHemorrhage = "postpartumHemorrhage",
}

export enum QuestionnaireTitle {
  FHR = "Fetal Heart Rate",
  LaborVitals = "Labor Vitals",
  LaborVitalSigns = "Labor Vital Signs",
  Contractions = "Contractions",
  CervicalExam = "Cervical Exam",
  ROM = "Rupture Of Membranes",
  Position = "Position",
  AssessmentNote = "Assessment Note",
  Birthing = "Birthing",
  Membranes = "Membranes",
  InputOutput = "Input/Output",
  MedsAndTherapies = "Meds & Therapies",
  NewLocation = "New Location",
  FullLaborUpdate = "Full Labor Update",
  AdmitDischarge = "Admission & Discharge",
  Transport = "Transport",
  EstimatedBloodLoss = "Estimated Blood Loss",
  Note = "Note",
  Resuscitation = "Resuscitation",
  ShoulderDystocia = "Shoulder Dystocia",
  PostpartumHemorrhage = "Postpartum Hemorrhage",
}

export const LABOR_QUESTIONNAIRE_TYPES = Object.values(QuestionnaireType);

export const LABOR_QUESTIONNAIRE_DISPLAY_NAMES: Record<QuestionnaireType, string> = {
  [QuestionnaireType.AdmitDischarge]: "Admission & Discharge",
  [QuestionnaireType.Transport]: "Transport",
  [QuestionnaireType.EstimatedBloodLoss]: "Estimated Blood Loss",
  [QuestionnaireType.ShoulderDystocia]: "Shoulder Dystocia",
  [QuestionnaireType.Birthing]: "Birthing",
  [QuestionnaireType.FetalHeartRate]: "Fetal Heart Rate",
  [QuestionnaireType.LaborVitals]: "Labor Vitals",
  [QuestionnaireType.Contractions]: "Contractions",
  [QuestionnaireType.CervicalExam]: "Cervical Exam",
  [QuestionnaireType.RuptureOfMembranes]: "Rupture of Membranes",
  [QuestionnaireType.Position]: "Position",
  [QuestionnaireType.AssessmentNote]: "Assessment Note",
  [QuestionnaireType.Membranes]: "Membranes",
  [QuestionnaireType.InputOutput]: "Input/Output",
  [QuestionnaireType.MedsAndTherapies]: "Meds & Therapies",
  [QuestionnaireType.NewLocation]: "New Location",
  [QuestionnaireType.FullLaborUpdate]: "Full Labor Update",
  [QuestionnaireType.Resuscitation]: "Resuscitation",
  [QuestionnaireType.PostpartumHemorrhage]: "Postpartum Hemorrhage",
};

export const LABOR_FLOW_SHEET_QUESTIONNAIRE_MAP: Record<QuestionnaireTitle, QuestionnaireType> = {
  [QuestionnaireTitle.FHR]: QuestionnaireType.FetalHeartRate,
  [QuestionnaireTitle.LaborVitals]: QuestionnaireType.LaborVitals,
  [QuestionnaireTitle.LaborVitalSigns]: QuestionnaireType.LaborVitals,
  [QuestionnaireTitle.Contractions]: QuestionnaireType.Contractions,
  [QuestionnaireTitle.CervicalExam]: QuestionnaireType.CervicalExam,
  [QuestionnaireTitle.ROM]: QuestionnaireType.RuptureOfMembranes,
  [QuestionnaireTitle.Position]: QuestionnaireType.Position,
  [QuestionnaireTitle.AssessmentNote]: QuestionnaireType.AssessmentNote,
  [QuestionnaireTitle.Birthing]: QuestionnaireType.Birthing,
  [QuestionnaireTitle.Membranes]: QuestionnaireType.Membranes,
  [QuestionnaireTitle.InputOutput]: QuestionnaireType.InputOutput,
  [QuestionnaireTitle.MedsAndTherapies]: QuestionnaireType.MedsAndTherapies,
  [QuestionnaireTitle.NewLocation]: QuestionnaireType.NewLocation,
  [QuestionnaireTitle.FullLaborUpdate]: QuestionnaireType.FullLaborUpdate,
  [QuestionnaireTitle.AdmitDischarge]: QuestionnaireType.AdmitDischarge,
  [QuestionnaireTitle.Transport]: QuestionnaireType.Transport,
  [QuestionnaireTitle.EstimatedBloodLoss]: QuestionnaireType.EstimatedBloodLoss,
  [QuestionnaireTitle.Note]: QuestionnaireType.AssessmentNote,
  [QuestionnaireTitle.Resuscitation]: QuestionnaireType.Resuscitation,
  [QuestionnaireTitle.ShoulderDystocia]: QuestionnaireType.ShoulderDystocia,
  [QuestionnaireTitle.PostpartumHemorrhage]: QuestionnaireType.PostpartumHemorrhage,
};
